import Axios from "axios";
import User from "@/entity/User";

export default class AuthService {
  public static async login(email: string, password: string): Promise<User> {
    const response = await Axios.post("login", { email, password });
    return response.data;
  }
}
